import type { CurationPickReason } from './types';

const KNOWN_REASONS: ReadonlySet<CurationPickReason> = new Set([
  'already_in_community',
  'already_picked',
  'duplicate_in_run',
  'niche_limit',
  'global_cap',
  'out_of_duration',
  'live_or_upcoming',
  'music_category',
  'wrong_language',
  'create_error',
  'quota_error',
]);

// Translation key for why a candidate was skipped or failed.
export function reasonLabelKey(reason: string | null | undefined): string {
  return reason && KNOWN_REASONS.has(reason as CurationPickReason)
    ? `admin.communityCuration.reasons.${reason}`
    : 'admin.communityCuration.reasons.unknown';
}
